import { OAuthProvider } from './oauth.provider'
import { container } from './container'

export class OAuthBennetProvider extends OAuthProvider {
	constructor () {
		super()
		this.url = 'https://www.bennet.com/'

		this.redirect_uri = location.protocol+'//'+location.host + '/oauth/bennet/token'
	}

	getAuthorizeUrl (options) {
		return this.url + (options && options.url == 'register' ? 'register' : 'login') + this.objToQuery({
			redirect_uri: this.redirect_uri
		})
	}

	getParamsAccessToken (vars) {
		return {
			redirect_uri: this.redirect_uri,
			access_token: container.get('services.cookies').get('Cross-SSO') // this cookie is httpOnly, so fuck it
		}
	}
}
